var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolWeatherAlerts01 = function SvgSolWeatherAlerts01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_weather_alerts-01_svg2__a",
    x1: 41.69,
    x2: 219.57,
    y1: 204.94,
    y2: 45.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_weather_alerts-01_svg2__a",
    id: "sol_weather_alerts-01_svg2__b",
    x1: 32.93,
    x2: 210.81,
    y1: 195.19,
    y2: 35.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_weather_alerts-01_svg2__a",
    id: "sol_weather_alerts-01_svg2__c",
    x1: 30.29,
    x2: 208.17,
    y1: 192.25,
    y2: 32.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_weather_alerts-01_svg2__a",
    id: "sol_weather_alerts-01_svg2__d",
    x1: 21.53,
    x2: 199.41,
    y1: 182.5,
    y2: 22.69
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_weather_alerts-01_svg2__a",
    id: "sol_weather_alerts-01_svg2__e",
    x1: 18.88,
    x2: 196.77,
    y1: 179.56,
    y2: 19.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_weather_alerts-01_svg2__a",
    id: "sol_weather_alerts-01_svg2__f",
    x1: 10.13,
    x2: 188.01,
    y1: 169.81,
    y2: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_weather_alerts-01_svg2__a",
    id: "sol_weather_alerts-01_svg2__g",
    x1: 25.5,
    x2: 203.38,
    y1: 186.93,
    y2: 27.11
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_weather_alerts-01_svg2__a",
    id: "sol_weather_alerts-01_svg2__h",
    x1: 53.84,
    x2: 231.72,
    y1: 218.47,
    y2: 58.66
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_weather_alerts-01_svg2__a",
    id: "sol_weather_alerts-01_svg2__i",
    x1: 71.35,
    x2: 249.24,
    y1: 237.97,
    y2: 78.15
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M63.39 180.66a3.84 3.84 0 0 0-5.22 1.53l-6.63 12.12a3.847 3.847 0 0 0 1.52 5.22 3.845 3.845 0 0 0 5.22-1.53l6.63-12.12c1.02-1.86.34-4.2-1.52-5.22",
    style: {
      fill: "url(#sol_weather_alerts-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59 145.79a3.84 3.84 0 0 0-5.22 1.53l-6.64 12.12a3.847 3.847 0 0 0 1.52 5.22 3.845 3.845 0 0 0 5.22-1.53l6.64-12.12c1.02-1.86.34-4.2-1.52-5.22",
    style: {
      fill: "url(#sol_weather_alerts-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.86 180.66a3.84 3.84 0 0 0-5.22 1.53L26 194.31a3.847 3.847 0 0 0 1.52 5.22 3.845 3.845 0 0 0 5.22-1.53l6.64-12.12c1.02-1.86.34-4.2-1.52-5.22",
    style: {
      fill: "url(#sol_weather_alerts-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.95 163.13 6.64-12.12a3.842 3.842 0 1 0-6.74-3.69l-6.64 12.12a3.847 3.847 0 0 0 1.52 5.22 3.845 3.845 0 0 0 5.22-1.53",
    style: {
      fill: "url(#sol_weather_alerts-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.33 180.66a3.84 3.84 0 0 0-5.22 1.53L.47 194.31a3.847 3.847 0 0 0 1.52 5.22A3.845 3.845 0 0 0 7.21 198l6.64-12.12c1.02-1.86.34-4.2-1.52-5.22",
    style: {
      fill: "url(#sol_weather_alerts-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.42 163.13 6.64-12.12a3.842 3.842 0 1 0-6.74-3.69l-6.64 12.12a3.847 3.847 0 0 0 1.52 5.22 3.845 3.845 0 0 0 5.22-1.53",
    style: {
      fill: "url(#sol_weather_alerts-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.92 118.06c17.27-.84 31.08-15.12 31.08-32.59 0-16.53-12.53-30.38-28.59-32.41-1.8-17.16-16.35-30.58-33.98-30.58-7.27 0-14.17 2.25-19.94 6.42C110.26 11.63 93.16 0 74.07 0 48.12 0 27.01 21.12 27.01 47.06c0 2.06.14 4.12.4 6.16C11.76 55.74.05 69.14.05 85.47c0 18.02 14.66 32.67 32.67 32.67h9.67l-3.52 6.42a3.847 3.847 0 0 0 1.52 5.22 3.845 3.845 0 0 0 5.22-1.53l5.54-10.12h16.76l-3.52 6.42a3.847 3.847 0 0 0 1.52 5.22 3.845 3.845 0 0 0 5.22-1.53l5.54-10.12h16.76l-3.52 6.42a3.847 3.847 0 0 0 1.52 5.22 3.845 3.845 0 0 0 5.22-1.53l5.54-10.12h17.63l-28.51 55.95c-2.83 5.56-2.58 12.06.68 17.39 3.26 5.32 8.94 8.5 15.18 8.5h74.42c6.24 0 11.92-3.18 15.18-8.5s3.52-11.82.68-17.39l-28.55-56.03Zm-136.2-7.61c-13.78 0-24.98-11.21-24.98-24.98s10.67-24.59 24.29-24.96a3.83 3.83 0 0 0 2.93-1.49c.71-.91.97-2.09.71-3.21-.65-2.86-.98-5.8-.98-8.75 0-21.71 17.66-39.37 39.37-39.37 17.64 0 33.24 11.86 37.94 28.83a3.85 3.85 0 0 0 2.75 2.7c1.33.34 2.75-.06 3.71-1.04 5.03-5.16 11.76-8.01 18.96-8.01 14.56 0 26.42 11.82 26.47 26.37v.11c0 2.1 1.69 3.82 3.79 3.85 13.57.2 24.61 11.4 24.61 24.97s-11.21 24.98-24.98 24.98h-2.28l-4.78-9.38c-3.06-6-9.13-9.72-15.87-9.72s-12.81 3.72-15.86 9.72l-4.78 9.38zm157.52 77.01a10.05 10.05 0 0 1-8.62 4.83H107.2c-3.55 0-6.77-1.81-8.62-4.83s-2-6.72-.39-9.88l37.21-73.02c1.76-3.46 5.13-5.52 9.01-5.52s7.25 2.06 9.01 5.52l37.21 73.02c1.61 3.16 1.47 6.85-.38 9.87Z",
    style: {
      fill: "url(#sol_weather_alerts-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4 152.65c2.12 0 3.85-1.72 3.85-3.85v-23.39c0-2.12-1.72-3.85-3.85-3.85s-3.85 1.72-3.85 3.85v23.39c0 2.12 1.72 3.85 3.85 3.85",
    style: {
      fill: "url(#sol_weather_alerts-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.96 170.86c-.1-.23-.23-.44-.36-.65-.14-.21-.29-.4-.48-.6a3.3 3.3 0 0 0-.58-.46c-.21-.15-.42-.27-.67-.37-.23-.1-.46-.17-.71-.21q-.75-.15-1.5 0c-.25.04-.5.12-.73.21-.23.1-.44.21-.65.37-.21.13-.4.29-.58.46-.19.19-.35.38-.48.6-.15.21-.27.42-.37.65s-.17.48-.21.73c-.06.25-.08.5-.08.75s.02.5.08.75c.04.25.11.48.21.71s.21.46.37.67c.14.21.29.4.48.58.17.17.37.35.58.48s.42.25.65.35.48.17.73.23c.25.04.5.08.75.08s.5-.04.75-.08c.25-.06.48-.13.71-.23.25-.1.46-.21.67-.35.21-.13.4-.31.58-.48.19-.17.35-.37.48-.58s.27-.44.36-.67c.1-.23.15-.46.21-.71s.08-.5.08-.75-.02-.5-.08-.75-.12-.5-.21-.73",
    style: {
      fill: "url(#sol_weather_alerts-01_svg2__i)"
    }
  }));
};
export default SvgSolWeatherAlerts01;